import * as React from 'react';
import { FC } from 'react';

import { Cell, Grid } from '@rbilabs/components-library';

import { MarketingCard } from 'components/features/components/marketing-card';
import { IMarketingCardFragment } from 'generated/sanity-graphql';
import { primitive } from 'styles/constants/primitives';

import { IMarketingCardGroupProps } from './types';

/**
 *
 * MarketingCardGroup renders a group of marketing cards in a grid
 *
 */
const MarketingCardGroup: FC<IMarketingCardGroupProps> = ({ doc, onShowTermsModal }) => {
  const cards = doc.Cards;
  if (!cards || cards.length <= 0) {
    return null;
  }
  return (
    <Grid data-testid="marketing-tile-group-grid" style={{ rowGap: primitive.$spacing4 }}>
      {cards?.map(card => {
        if (!card) {
          return null;
        }
        const key = `MarketingCard_${card._id}`;
        return (
          <Cell key={key} span={2} spanTablet={4} spanDesktopLarge={6}>
            <MarketingCard
              card={card as IMarketingCardFragment}
              onShowTermsModal={onShowTermsModal}
            />
          </Cell>
        );
      })}
    </Grid>
  );
};

export default MarketingCardGroup;
